import { inputTypes } from 'components/common/FormElements/Input'
import {
  USER_PLAN_DROP_OFF,
  USER_PLAN_WAIT,
  PHONE_MASK,
  USER_PLAN_DROP_OFF_DESCRIPTION,
  USER_PLAN_WAIT_DESCRIPTION
} from 'constant'
import { FIRST_NAME, LAST_NAME, EMAIL, PHONE_NUMBER, USER_PLAN, CUSTOMER_HEADER_ID, WAIT_DROPOFF_HEADER_ID } from '../constants'
import { PHONE_HEADER_ID, EMAIL_HEADER_ID } from './constants'
import { KEEP_IN_CONTACT_PROPERTY_NEW, TERMS_AGREEMENT_PROPERTY } from 'components/Login/CreateAccount/CreateAccountFormPage/constants'

export default {
  firstName: {
    label: 'First Name*',
    name: FIRST_NAME,
    required: true,
    'aria-describedby': CUSTOMER_HEADER_ID
  },
  lastName: {
    label: 'Last Name*',
    name: LAST_NAME,
    required: true,
    'aria-describedby': CUSTOMER_HEADER_ID
  },
  phoneNumber: {
    label: 'Phone Number*',
    name: PHONE_NUMBER,
    mask: PHONE_MASK,
    required: true,
    'aria-describedby': PHONE_HEADER_ID
  },
  email: {
    label: 'Your Email*',
    name: EMAIL,
    required: true,
    'aria-describedby': EMAIL_HEADER_ID
  },
  userPlan: {
    dropOff: {
      label: 'Drop Off Car',
      name: USER_PLAN,
      type: 'radio',
      value: USER_PLAN_DROP_OFF,
      inputType: inputTypes.RADIO_INPUT,
      description: USER_PLAN_DROP_OFF_DESCRIPTION,
      'aria-describedby': WAIT_DROPOFF_HEADER_ID
    },
    wait: {
      label: 'Wait in Store',
      name: USER_PLAN,
      type: 'radio',
      value: USER_PLAN_WAIT,
      inputType: inputTypes.RADIO_INPUT,
      description: USER_PLAN_WAIT_DESCRIPTION,
      'aria-describedby': WAIT_DROPOFF_HEADER_ID
    }
  },
  keepInContact: {
    name: KEEP_IN_CONTACT_PROPERTY_NEW,
    inputType: inputTypes.CHECKBOX_INPUT,
    value: true,
    'data-at-quick-appointment-keepincontact': true
  },
  termsAgreement: {
    name: TERMS_AGREEMENT_PROPERTY,
    label: 'I understand and agree that registration on or use of this site constitutes acceptance of our',
    inputType: inputTypes.CHECKBOX_INPUT,
    linkLabel: 'Privacy Policy',
    'data-at-quick-appointment-agree': true,
    required: true
  }
}
